import { useState } from "react"

type DeleteDialogProps = {

    index?     : number,
    title      : string, 
    description: string,

    /* Button styling for trigger button */
    btnClass: string,
    btnIcon:  string,
    btnText?: string,

    /* Callback method that passes */
    onConfirm: (index? : number) => void
}

const DeleteDialog = ({ index, title, description, btnClass, btnIcon, btnText, onConfirm }: DeleteDialogProps) => {

    const [show, setShow] = useState<boolean>(false);

    /**
     * TBD ....
     */
    function handleConfirm(): void {

        /* Hide dialog from user and invoke callback method */

        setShow(false);
        onConfirm(index);
    }

    return (
        <>
            <button className={btnClass} onClick={e => setShow(true)} >
                <i className={btnIcon} /> {btnText}
            </button>

            <div className={"modal fade" + (show ? " show" : "")} role="dialog" tabIndex={-1}>
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h5>{title}</h5>
                            <button type="button" className="btn-close" onClick={e => setShow(false)}></button>
                        </div>

                        <div className="modal-body">
                            <p>{description}</p>
                        </div>

                        <div className="modal-footer">
                            <button className="btn btn-danger" type="button" onClick={e => setShow(false)}>Close</button>
                            <button className="btn btn-success" type="button" onClick={handleConfirm}>Confirm</button>                            
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default DeleteDialog;